import { IconBase, type IconProps } from './IconBase';

export function CheckIcon(props: IconProps) {
  return (
    <IconBase strokeWidth={2.25} {...props}>
      <path d="M5 12l4 4 10-10" />
    </IconBase>
  );
}
